import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function LinkedInShareIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M5.90714 4.22321C5.90684 4.81255 5.6744 5.37763 5.26095 5.79415C4.84749 6.21066 4.28689 6.44449 3.70247 6.4442C3.11804 6.4439 2.55767 6.20951 2.14463 5.79257C1.73159 5.37564 1.49971 4.81033 1.5 4.22099C1.50029 3.63165 1.73273 3.06657 2.14619 2.65005C2.55965 2.23354 3.12025 1.99971 3.70467 2C4.28909 2.00029 4.84946 2.23469 5.2625 2.65162C5.67555 3.06856 5.90743 3.63387 5.90714 4.22321ZM5.97324 8.08966H1.56611V22H5.97324V8.08966ZM12.9365 8.08966H8.55142V22H12.8924V14.7004C12.8924 10.634 18.148 10.2562 18.148 14.7004V22H22.5V13.1894C22.5 6.3342 14.7214 6.58975 12.8924 9.95622L12.9365 8.08966Z"
        fill="inherit"
      />
    </SvgIcon>
  );
}
